import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Page from 'components/system/Page';
import Paper from 'components/system/Paper';
import colors from 'styles/colors';

const JobsEmptyList = () => {
  const navigate = useNavigate();
  return (
    <Page>
      <Paper>
        <Box
          sx={{
            display: 'flex',
            height: '100%',
            width: '100%',
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box>
            <Typography variant="h5" color={colors.text.primary}>
              No jobs yet
            </Typography>
            <Typography variant="body2" sx={{ color: colors.text.tetriary, padding: '20px 0' }}>
              Jobs you submit through bluequbit.run(circuit) will appear here
            </Typography>
            <Button type="primary" variant="contained" onClick={() => navigate('/docs#a_b')}>
              Get Started with A + B
            </Button>
          </Box>
        </Box>
      </Paper>
    </Page>
  );
};

export default JobsEmptyList;
